var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReport24DpFill1Wght300Grad0Opsz24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "24px",
    viewBox: "0 -960 960 960",
    width: "24px",
    fill: "#ffffff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M480-291.54q13.73 0 23.02-9.29t9.29-23.02q0-13.73-9.29-23.02-9.29-9.28-23.02-9.28t-23.02 9.28q-9.29 9.29-9.29 23.02t9.29 23.02q9.29 9.29 23.02 9.29Zm.01-139.23q12.76 0 21.37-8.62 8.62-8.63 8.62-21.38v-181.54q0-12.75-8.63-21.37-8.63-8.63-21.38-8.63-12.76 0-21.37 8.63-8.62 8.62-8.62 21.37v181.54q0 12.75 8.63 21.38 8.63 8.62 21.38 8.62ZM368.39-140q-14.64 0-27.9-5.62-13.26-5.61-23.1-15.46L161.08-317.39q-9.85-9.84-15.46-23.1-5.62-13.26-5.62-27.9v-223.22q0-14.64 5.62-27.9 5.61-13.26 15.46-23.1l156.31-156.31q9.84-9.85 23.1-15.46 13.26-5.62 27.9-5.62h223.22q14.64 0 27.9 5.62 13.26 5.61 23.1 15.46l156.31 156.31q9.85 9.84 15.46 23.1 5.62 13.26 5.62 27.9v223.22q0 14.64-5.62 27.9-5.61 13.26-15.46 23.1L642.61-161.08q-9.84 9.85-23.1 15.46-13.26 5.62-27.9 5.62H368.39Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport24DpFill1Wght300Grad0Opsz24);
export default __webpack_public_path__ + "static/media/report_24dp_FILL1_wght300_GRAD0_opsz24.3df43ce419cbd6882011425afeca307c.svg";
export { ForwardRef as ReactComponent };